﻿package com.mgacreative.hotelru.domain.repository

import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.domain.model.Supplier
import com.mgacreative.hotelru.domain.model.SupplierCategory
import io.github.jan.supabase.postgrest.postgrest

interface SupplierRepository {
    suspend fun getCategories(): List<SupplierCategory>
    suspend fun createCategory(category: SupplierCategory): SupplierCategory?
    suspend fun deleteCategory(id: String)
    
    suspend fun getSuppliers(): List<Supplier>
    suspend fun createSupplier(supplier: Supplier): Supplier?
    suspend fun deleteSupplier(id: String)
}

class SupplierRepositoryImpl(
    private val networkClient: SupabaseNetworkClient
) : SupplierRepository {

    override suspend fun getCategories(): List<SupplierCategory> {
        return try {
            networkClient.client.postgrest["supplier_categories"]
                .select()
                .decodeList<SupplierCategory>()
        } catch (e: Exception) {
            e.printStackTrace()
            emptyList()
        }
    }

    override suspend fun createCategory(category: SupplierCategory): SupplierCategory? {
        return try {
            networkClient.client.postgrest["supplier_categories"]
                .insert(category) {
                    select()
                }
                .decodeSingleOrNull<SupplierCategory>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }

    override suspend fun deleteCategory(id: String) {
        try {
            networkClient.client.postgrest["supplier_categories"]
                .delete {
                    filter { eq("id", id) }
                }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
        }
    }

    override suspend fun getSuppliers(): List<Supplier> {
        return try {
            networkClient.client.postgrest["suppliers"]
                .select()
                .decodeList<Supplier>()
        } catch (e: Exception) {
            e.printStackTrace()
            emptyList()
        }
    }

    override suspend fun createSupplier(supplier: Supplier): Supplier? {
        return try {
            networkClient.client.postgrest["suppliers"]
                .insert(supplier) {
                    select()
                }
                .decodeSingleOrNull<Supplier>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }

    override suspend fun deleteSupplier(id: String) {
        try {
            networkClient.client.postgrest["suppliers"]
                .delete {
                    filter { eq("id", id) }
                }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
        }
    }
}

